<template>
  <div ref="dropdownSelect" class="component-select">
    <Field v-slot="{ field, meta }" v-model="data" type="text" :name="name" :rules="rules">
      <input v-show="false" v-bind="field" />

      <button
        type="button"
        :style="styleN"
        :class="[
          classN,
          'flex-right-dropdown',
          data ? 'colorBlack' : '',
          { 'form-control-error': !meta.valid && (meta.touched || meta.validated) },
        ]"
        :name="name + 'Select'"
        :disabled="disabled"
        @click="toggleDropdown()"
      >
        <div class="name-dropdown">{{ data ? data : placeholder }}</div>
        <font-awesome-icon
          v-if="data"
          icon="circle-xmark"
          class="pointer clear-icon"
          alt="clear"
          @click.stop="disabled ? '' : clearSelect()"
        />
        <font-awesome-icon v-else icon="angle-down" class="pointer" />
      </button>
    </Field>
    <ErrorMessage v-slot="{ message }" :name="name">
      <p class="message-error">{{ message }}</p>
    </ErrorMessage>
    <div class="dropdown-content" :style="dropdown ? 'display: block; overflow: auto;' : 'display: none;'">
      <div>
        <div v-show="zeroSelect" class="add placeholder" @click="select({ value: '', name: '' })">
          {{ placeholder }}
        </div>
      </div>
      <div v-for="(item, index) in optionSelect" :key="index">
        <div v-show="index != 0 || zeroSelect" class="line"></div>
        <div class="add" @click="select(item)">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ComponentSelect',
  props: ['name', 'placeholder', 'modelValue', 'classN', 'styleN', 'disabled', 'rules', 'optionSelect', 'zeroSelect'],
  data() {
    return {
      dropdown: false,
      data: '',
    }
  },
  watch: {
    modelValue() {
      if (this.modelValue !== undefined && this.modelValue !== null) {
        this.setDataValue()
      } else {
        this.data = ''
        this.$emit('change', '')
      }
    },
    optionSelect() {
      if (this.modelValue !== undefined && this.modelValue !== null) {
        this.setDataValue()
      } else {
        this.data = ''
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.focusoutBtn)
    if (this.modelValue) {
      this.setDataValue()
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdown = !this.dropdown
    },
    focusoutBtn(e) {
      if (this.$refs.dropdownSelect) {
        let target = e.target
        if (this.$refs.dropdownSelect !== target && !this.$refs.dropdownSelect.contains(target)) {
          this.dropdown = false
        }
      }
    },
    select(data) {
      this.$emit('update:modelValue', data.value)
      this.$emit('user-change', data.value)
      this.dropdown = false
      this.data = data.name
    },
    setDataValue() {
      const found = (this.optionSelect || []).find((row) => row.value == this.modelValue)
      if (found) {
        this.data = found.name
        this.$emit('update:modelValue', found.value)
        this.$emit('change', found.value)
      } else {
        this.data = ''
      }
    },
    clearSelect() {
      this.data = ''
      this.$emit('update:modelValue', '')
      this.$emit('change', '')
      this.dropdown = false
    },
  },
}
</script>
<style scoped lang="scss">
.component-select {
  position: relative;
  display: inline-block;
  width: 100%;
  .flex-right-dropdown {
    display: flex;
    height: 35px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid #c1cfe3;
    background-color: #ffffff;
    position: relative;
    align-items: center;
    justify-content: space-between;
    padding-left: 16px;
    padding-right: 16px;
    .name-dropdown {
      padding-right: 10px;
      font-size: 16px;
      color: #1a456b;
      opacity: 0.7;
      text-align: left;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0;
    }
    .clear-icon {
      font-size: 14px;
      opacity: 0.5;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .colorBlack .name-dropdown {
    padding-right: 10px;
    color: #212529;
    opacity: 1;
    font-size: 1rem;
    font-weight: 400;
  }
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #ffffff;
    min-width: 200px;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.16);
    text-align: left;
    z-index: 2;
    color: #0a1629;
    font-size: 20px;
    font-weight: 400;
    border-radius: 10px;
    left: 0;
    right: 0;
    margin-top: 8px;
    overflow: hidden;
    max-height: 420px;
    width: fit-content;

    .placeholder {
      color: #1a456b;
      opacity: 0.7;
      margin-bottom: -6px;
      font-size: 12px;
    }

    .add {
      padding-left: 22px;
      padding-right: 22px;
      padding-top: 15px;
      padding-bottom: 15px;
      width: 100%;
      cursor: pointer;
      .icon {
        margin-right: 6px;
      }
    }
    .line {
      border-bottom: 1px solid #d8d8d8;
      height: 0px !important;
      opacity: 1 !important;
      margin: 0px !important;
      padding: 0px !important;
    }
  }

  .pointer {
    width: 10px;
    height: 15px;
  }
}
</style>
